<ng-template #productNavigation>
  <div class="product-navigation-links">
    <a routerLink="/" (click)="closeMenu()">{{ 'common.HEADER.HOME' | translate }}</a>
    <a routerLink="/limited" (click)="closeMenu()">{{ 'common.HEADER.LIMITED' | translate }}</a>
    <ng-container *ngFor="let category of categoriesWithSub">
      <details *ngIf="category.subCategories?.length; else categoryLink">
        <summary>{{ categoryLabel(category) }}</summary>
        <a
          *ngFor="let sub of category.subCategories"
          routerLink="/product"
          [queryParams]="{ subCategory: sub.id }"
          (click)="closeMenu()"
        >{{ sub.name }}</a>
      </details>
      <ng-template #categoryLink>
        <a routerLink="/product" [queryParams]="{ category: category.id }" (click)="closeMenu()">
          {{ categoryLabel(category) }}
        </a>
      </ng-template>
    </ng-container>
  </div>
</ng-template>

<header class="site-header" [class.is-scrolled]="isScrolled">
  <div class="top-bar">
    <div class="container">
      <ng-container *ngIf="authService.isLoggedIn() | async; else guestMenuButton">
        <button
          type="button"
          class="mobile-menu-btn"
          [attr.aria-label]="'common.HEADER.OPEN_MENU' | translate"
          [attr.aria-expanded]="mobileMenuOpen"
          aria-controls="mobile-account-menu"
          (click)="toggleMobileMenu()"
        >
          <mat-icon aria-hidden="true">menu</mat-icon>
        </button>
      </ng-container>

      <ng-template #guestMenuButton>
        <button
          #guestMenuToggle
          type="button"
          class="mobile-menu-btn guest-menu-toggle"
          [attr.aria-label]="(guestMenuOpen ? 'common.HEADER.CLOSE_MENU' : 'common.HEADER.OPEN_MENU') | translate"
          [attr.aria-expanded]="guestMenuOpen"
          aria-controls="guest-mobile-navigation"
          (click)="toggleGuestMenu()"
        >
          <mat-icon aria-hidden="true">{{ guestMenuOpen ? 'close' : 'menu' }}</mat-icon>
        </button>
      </ng-template>

      <div class="mobile-logo" routerLink="/">
        <img src="assets/img/logo-a1102.svg" alt="1NO2" />
      </div>

      <div class="mobile-search-toggle" (click)="toggleMobileSearch()">
        <mat-icon>search</mat-icon>
      </div>

      <nav class="top-nav" [class.mobile-search-open]="isMobileSearchOpen">
        <div class="search-bar">
          <input type="text" [placeholder]="'common.HEADER.SEARCH_PRODUCT' | translate" 
                 [value]="searchKeyword"
                 (input)="onSearchInput($event)"
                 (keyup.enter)="onSearch()"
                 (focus)="showQuickSearchDropdown = searchKeyword.trim().length > 0">
          <button (click)="onSearch()" class="desktop-search-btn">
            <mat-icon>search</mat-icon>
          </button>
          <button (click)="toggleMobileSearch()" class="mobile-close-btn">
            <mat-icon>close</mat-icon>
          </button>

          <!-- Quick Search Dropdown -->
          <div class="quick-search-dropdown" *ngIf="showQuickSearchDropdown">
            <div class="loading-state" *ngIf="isQuickSearchLoading">
              <mat-spinner diameter="30"></mat-spinner>
            </div>
            
            <div class="quick-search-results" *ngIf="!isQuickSearchLoading">
              <div class="search-top-bar" *ngIf="quickSearchResults.length > 0">
                <span class="search-result-count">{{ 'common.HEADER.SEARCH_RESULT_COUNT_PREFIX' | translate }}<strong>{{ quickSearchTotalCount }}</strong>{{ 'common.HEADER.SEARCH_RESULT_COUNT_SUFFIX' | translate }} "{{ searchKeyword.trim() }}"</span>
                <span class="view-all-results" (click)="onSearch()">
                  {{ 'common.HEADER.VIEW_ALL_SEARCH_RESULTS' | translate }} <mat-icon>arrow_forward</mat-icon>
                </span>
              </div>

              <div class="quick-search-item" *ngFor="let item of quickSearchResults" (click)="goToProduct(item.slug || item.id)">
                <div class="item-img-wrapper">
                  <img [src]="resolveImageUrl(item.mainImageUrl)" [alt]="item.name" *ngIf="item.mainImageUrl" />
                  <div class="no-img" *ngIf="!item.mainImageUrl"><mat-icon>image</mat-icon></div>
                </div>
                <div class="item-info">
                  <h4 class="item-name" [innerHTML]="highlightText(item.name, searchKeyword)"></h4>
                  <div class="item-price-row">
                    <span class="item-price">{{ item.price | number: '1.0-0' }}đ</span>
                    <span class="item-original-price" *ngIf="item.originalPrice">{{ item.originalPrice | number: '1.0-0' }}đ</span>
                  </div>
                  <div class="item-sku" *ngIf="item.sku">SKU: <span [innerHTML]="highlightText(item.sku, searchKeyword)"></span></div>
                </div>
              </div>

              <div class="no-results" *ngIf="quickSearchResults.length === 0 && searchKeyword.length > 0">
                {{ 'common.HEADER.NO_SEARCH_RESULTS' | translate:{ keyword: searchKeyword } }}
              </div>

              <div class="view-all-results-bottom" *ngIf="quickSearchResults.length > 0" (click)="onSearch()">
                {{ 'common.HEADER.VIEW_ALL_SEARCH_RESULTS_FOR' | translate:{ keyword: searchKeyword } }} <mat-icon>arrow_forward</mat-icon>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <div class="right-actions">




        <ng-container *ngIf="authService.isLoggedIn() | async">
          <div class="header-icons">
            <div class="icon-wrapper" (click)="onCartClick()">
              <img src="assets/icons/bag_header.svg" class="icon" />
              <span *ngIf="cartQuantities !== 0" class="cart__badge">
                {{ cartQuantities }}
              </span>
            </div>

            <div class="icon-wrapper heart-wrapper" (click)="onWishlistClick()">
              <img
                src="assets/icons/heart_header.svg"
                class="icon heart"
                [title]="'common.HEADER.WISHLIST' | translate"
              />
              <span *ngIf="wishlistQuantities !== 0" class="cart__badge">
                {{ wishlistQuantities }}
              </span>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="authService.isLoggedIn() | async; else loggedOut">
          <div class="auth logged-in-auth">
            <a routerLink="/profiles" class="auth-link info-link">
              <mat-icon>person</mat-icon>
              <span>{{ 'common.HEADER.HELLO' | translate }} {{ personalData?.firstName || personalData?.userName || ('common.HEADER.USER' | translate) }}</span>
            </a>
            <span class="auth-divider">|</span>
            <a (click)="logout()" class="auth-link logout-link" [title]="'common.HEADER.LOGOUT' | translate">
              <mat-icon>logout</mat-icon>
            </a>
          </div>
        </ng-container>

        <ng-template #loggedOut>
          <div class="auth logged-out-auth">
            <a (click)="openAuthModal('login')" class="auth-link" style="cursor: pointer;">
              <mat-icon>person</mat-icon>
              <span>{{ 'common.HEADER.LOGIN' | translate }}</span>
            </a>
            <span class="auth-divider">|</span>
            <a (click)="openAuthModal('register')" class="auth-link" style="cursor: pointer;">
              <span>{{ 'common.HEADER.REGISTER' | translate }}</span>
            </a>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <nav
    *ngIf="guestMenuOpen && !(authService.isLoggedIn() | async)"
    id="guest-mobile-navigation"
    class="guest-navigation"
    [attr.aria-label]="'common.HEADER.NAVIGATION' | translate"
  >
    <ng-container *ngTemplateOutlet="productNavigation"></ng-container>
  </nav>

  <div class="main-menu">
    <div class="container main-menu-flex">
      <div class="logo">
        <img
          routerLink="/"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          src="assets/img/logo-a1102.svg"
          alt="1NO2"
        />
      </div>
      <nav class="menu">
        <a
          routerLink="/"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          {{ 'common.HEADER.HOME' | translate }}
        </a>

        <a
          routerLink="/limited"
          routerLinkActive="active"
        >
          {{ 'common.HEADER.LIMITED' | translate }}
        </a>

        <ng-container *ngFor="let category of categoriesWithSub">
          <div
            class="menu-item"
            *ngIf="category.subCategories?.length; else simpleLink"
            (mouseenter)="onMenuEnter(category.id)"
            (mouseleave)="onMenuLeave()"
          >
            <a
              class="menu-link"
              [class.active]="openedCategoryId === category.id"
              (click)="onCategoryTabClick(category.id, $event)"
            >
              {{ categoryLabel(category) }}
            </a>

            <div
              class="mega-panel"
              [class.visible]="openedCategoryId === category.id"
            >
              <div class="panel-inner">
                <aside class="sidebar">
                  <ul>
                    <li
                      *ngFor="let cate of categoriesWithSub"
                      (mouseenter)="onSidebarEnter(cate.id)"
                      [class.active-sub]="activeSidebarCategoryId === cate.id"
                    >
                      <a>{{ categoryLabel(cate) }}</a>
                      <mat-icon class="arrow-icon">chevron_right</mat-icon>
                    </li>
                  </ul>
                </aside>

                <section class="content-panel">
                  <ng-container *ngFor="let cate of categoriesWithSub">
                    <div
                      class="category-panel"
                      *ngIf="activeSidebarCategoryId === cate.id"
                    >
                      <div class="content-header">
                        <mat-icon class="header-icon">apps</mat-icon>
                        <h2>{{ 'common.HEADER.CATEGORY' | translate }} {{ categoryLabel(cate) }}</h2>
                      </div>

                      <div class="filter-list">
                        <div
                          class="filter-item"
                          *ngFor="let sub of cate.subCategories"
                        >
                          <a
                            [routerLink]="['/product']"
                            [queryParams]="{ subCategory: sub.id }"
                            class="circle"
                            (click)="onMenuLeave()"
                          >
                            <div class="circle" *ngIf="sub.imageUrl">
                              <img
                                [src]="resolveImageUrl(sub.imageUrl)"
                                [alt]="sub.name"
                              />
                            </div>
                          </a>
                          <span>{{ sub.name }}</span>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </section>
              </div>
            </div>
          </div>

          <ng-template #simpleLink>
            <a
              class="menu-link"
              [routerLink]="['/product']"
              [queryParams]="{ category: category.id }"
              [class.active]="isCategoryActive(category.id)"
            >
              {{ categoryLabel(category) }}
            </a>
          </ng-template>
        </ng-container>
      </nav>


    </div>
  </div>
</header>

<div
  class="mobile-menu-overlay"
  *ngIf="mobileMenuOpen"
  (click)="toggleMobileMenu()"
>
  <div id="mobile-account-menu" class="mobile-menu open" (click)="$event.stopPropagation()">
    <div class="mobile-menu-header">
      <ng-container *ngIf="authService.isLoggedIn() | async; else mobileLoggedOutGreeting">
        <div class="user-greeting">
          <div class="avatar-placeholder">
            <mat-icon>person</mat-icon>
          </div>
          <div class="greeting-text">
            <span class="hello-text">{{ 'common.HEADER.HELLO' | translate }}</span>
            <span class="user-name">{{ personalData?.firstName || personalData?.userName || ('common.HEADER.USER' | translate) }}</span>
          </div>
        </div>
      </ng-container>
      <ng-template #mobileLoggedOutGreeting>
        <div class="user-greeting" (click)="openAuthModal('login'); closeMenu()" style="cursor: pointer;">
          <div class="avatar-placeholder">
            <mat-icon>person</mat-icon>
          </div>
          <div class="greeting-text">
            <span class="hello-text">{{ 'common.HEADER.ACCOUNT' | translate }}</span>
            <span class="user-name" style="color: #FF9800; font-weight: 700;">{{ 'common.HEADER.LOGIN_REGISTER' | translate }}</span>
          </div>
        </div>
      </ng-template>
      <mat-icon (click)="toggleMobileMenu()" class="close-btn">close</mat-icon>
    </div>

    <div class="mobile-user-section">
      <div class="mobile-quick-actions">
        <details class="account-product-navigation">
          <summary class="action-item">
            <mat-icon aria-hidden="true">category</mat-icon>
            <span>{{ 'common.HEADER.PRODUCT_CATEGORIES' | translate }}</span>
            <mat-icon class="expand-icon" aria-hidden="true">expand_more</mat-icon>
          </summary>
          <nav [attr.aria-label]="'common.HEADER.PRODUCT_CATEGORIES' | translate">
            <ng-container *ngTemplateOutlet="productNavigation"></ng-container>
          </nav>
        </details>

        <div class="action-item" routerLink="/profiles" [queryParams]="{tab: 'dashboard'}" (click)="closeMenu()">
          <mat-icon>layers</mat-icon>
          <span>{{ 'TABS.DASHBOARD' | translate }}</span>
        </div>
        
        <div class="action-item" routerLink="/profiles" [queryParams]="{tab: 'order_history'}" (click)="closeMenu()">
          <mat-icon>store</mat-icon>
          <span>{{ 'TABS.ORDER_HISTORY' | translate }}</span>
        </div>
        
        <div class="action-item" routerLink="/profiles" [queryParams]="{tab: 'measurement'}" (click)="closeMenu()">
          <mat-icon>straighten</mat-icon>
          <span>{{ 'TABS.MEASUREMENT' | translate }}</span>
        </div>
        
        <div class="action-item" routerLink="/profiles" [queryParams]="{tab: 'wishlist'}" (click)="closeMenu()">
          <mat-icon>favorite</mat-icon>
          <span>{{ 'TABS.WISHLIST' | translate }}</span>
        </div>
        
        <div class="action-item" routerLink="/profiles" [queryParams]="{tab: 'design'}" (click)="closeMenu()">
          <mat-icon>design_services</mat-icon>
          <span>{{ 'TABS.DESIGN' | translate }}</span>
        </div>
        
        <div class="action-item" routerLink="/profiles" [queryParams]="{tab: 'invoice'}" (click)="closeMenu()">
          <mat-icon>receipt_long</mat-icon>
          <span>{{ 'TABS.INVOICE_INFO' | translate }}</span>
        </div>
        
        <div class="action-item" routerLink="/profiles" [queryParams]="{tab: 'settings'}" (click)="closeMenu()">
          <mat-icon>settings</mat-icon>
          <span>{{ 'TABS.SETTINGS' | translate }}</span>
        </div>

      </div>
      
      <div class="mobile-logout-section">
        <div class="action-item logout" (click)="logout(); closeMenu()">
          <mat-icon>logout</mat-icon>
          <span>{{ 'common.HEADER.LOGOUT' | translate }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
